import React from 'react';
import { Card, CardContent, Skeleton, Box } from '@mui/material';

const PlaceCardSkeleton = () => {
    return (
        <Card>
            <CardContent>
                <Box ml={2}>
                    <Skeleton variant="text" width="80%" height={32} />
                    <Box sx={{ m: 1 }} />
                    <Skeleton variant="text" width="60%" height={20} />
                    <Box sx={{ m: 1 }} />
                    <Skeleton variant="text" width="40%" height={20} />
                    <Box sx={{ m: 1 }} />
                    <Skeleton variant="text" width="30%" height={20} />
                    <Box sx={{ m: 1 }} />
                    <Box display="flex" gap={1}>
                        <Skeleton variant="rounded" width={60} height={24} />
                        <Skeleton variant="rounded" width={80} height={24} />
                        <Skeleton variant="rounded" width={70} height={24} />
                    </Box>
                    <Box sx={{ m: 1 }} />
                    <Skeleton variant="text" width="100%" height={1} />
                    <Box sx={{ m: 1 }} />
                    <Box display="flex" justifyContent="space-between">
                        <Skeleton variant="text" width="20%" height={20} />
                        <Skeleton variant="text" width="25%" height={20} />
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default PlaceCardSkeleton; 